import { z } from 'zod/v3';
import { llmMessageSchema } from './message';
export { llmMessageSchema } from './message';
import { Parser } from '@cotera/era';

export type LLMMessage = z.infer<typeof llmMessageSchema>;

const completionBaseSchema = z.object({
  model: z.string(),
  maxOutputTokens: z.number().optional(),
  expectedType: Parser.ExtendedAttributeTypeSchema.optional(),
  tools: z.array(z.string()).optional(),
  durable: z.boolean().optional(),
  temperature: z.number().optional(),
  topP: z.number().optional(),
  topK: z.number().optional(),
  frequencyPenalty: z.number().optional(),
  presencePenalty: z.number().optional(),
});

const completionParamsWithMessagesSchema = completionBaseSchema.extend({
  messages: llmMessageSchema.array(),
});

const completionWithMessagesPtrSchema = completionBaseSchema.extend({
  messages: z.object({ ptr: z.string().uuid() }),
});

export const completionParamSchema = completionBaseSchema.extend({
  messages: z.union([
    llmMessageSchema.array(),
    z.object({ ptr: z.string().uuid() }),
  ]),
});

const llmErrorSchema = z.enum([
  'CacheMiss',
  'LlmError',
  'ValidationError',
  'NotFound',
  'TransientError',
  'StructuredOutputNotSupported',
  'NotEnoughOutputTokens',
  'Refusal',
  'UnsupportedModel',
  'ImagesNotSupported',
  'InvalidStructuredOutput',
  'ToolNotFound',
  'UnexpectedToolCall',
  'ToolCredentialsFailure',
  'ToolInputValidationError',
  'ToolOutputValidationError',
  'ToolCallFailed',
]);
